import {
  goalEvolutionResponseSchema,
  type GoalEvolutionResponse,
} from '@/features/benchmarking/schemas/benchmarkingGoalEvolution';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export type GetBenchmarkingGoalEvolutionParams = { escolaId: number };

export const getBenchmarkingGoalEvolution = httpGetAdapter<GoalEvolutionResponse, GetBenchmarkingGoalEvolutionParams>({
  url: (params) => `/v3/microdados/escola/${params.escolaId}/evolucao-meta`,
  schema: goalEvolutionResponseSchema,
});
